import { tokens } from '@welbe/web-design-system';
import styled from 'styled-components';

export const ContainerDonut = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	font-family: ${tokens.font_family_primary};
	gap: 8px;

	svg {
		background: white;
		border-radius: 50%;
	}

	h3 {
		color: ${tokens.color_gray_dark};
		text-align: center;
		font-weight: 500;
		font-size: 18px;
		margin-top: 18px;

		b {
			font-weight: 700;
		}
	}

	h4 {
		color: ${tokens.color_gray_dark};
		text-align: center;
		font-weight: 500;
		font-size: 14px;
	}
`;
